import _ from 'lodash';
import React, { Component } from 'react';
import axios from 'axios';
import DecoratedEditor from './DecoratedEditor';
import Card from '@material-ui/core/Card';


class Medical extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entries: null,
    };
    props.setActiveComponent('Medicine');
  }

  async componentDidMount() {
    window.scrollTo(0, 0)
    const res = await axios.get('/api/posts_v2?category=Medicine');
    const entries = _.get(res, 'data');
    if (entries && entries.length) {
      this.setState({ entries });
    }
  }

  render() {
    const { entries } = this.state;
    return (
      <div id="medical">
        {_.map(entries, entry => (
          <Card className="blog-entry-card" raised>
            <DecoratedEditor entry={entry} />
          </Card>
        ))}
      </div>
    );
  }
}

export default Medical;
